enum TicketCheckActions {
  close = 'close',
  cancel = 'cancel',
  rebet = 'rebet',
  payout = 'payout',
  activate = 'activate',
}

export default TicketCheckActions;
